import api from '@/api';
import { API_BASE_URL } from '../..';

const CONTROLLER_URL = `${API_BASE_URL}/EmailReportLink`;

export async function getQuestEmailReportLink(processId: string) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/${processId}`,
  )) as unknown;

  return result as BlobPart;
}
